import { FC } from "react";

import Skeleton from "../Skeleton/Skeleton";
import TableSkeleton from "../Table/TableSkeleton";

import styles from "./CardDailyModel.module.css";



const CardDailyModelSkeleton: FC = () => {
  return (
    <div className={styles['models-daily']}>
      <div className={styles['models-daily__header']}>
        <h3 className={styles['models-daily__title']}><Skeleton height={40} width={400} variant="text" /></h3>
        <div className={styles['models-daily__info']}>
          <div className={styles['models-daily__info-label']}><Skeleton height={24} width={161} variant="text" /></div>
          <div className={styles['models-daily__value']}><Skeleton height={56} width={88} /></div>
        </div>
      </div>

      <TableSkeleton 
        rows={10}
        columns={4}
      />
    </div>
  )
};

export default CardDailyModelSkeleton;